
import React, { Component } from "react";
import {Text, Tag} from "@chakra-ui/react";


export default class MultiEntryDisplay extends Component 
{


    render() 
    {
        return(                
            <Text fontSize={{ base: '14px', md: '20px', lg: '24px' }} color="#0095c8" margin='0'>{this.props.cardValue.map((v) => {return <Tag margin={'2px'}>{v}</Tag>})}</Text>
        )
    }
}







